<template>
	<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M29.3333 16C29.3333 8.66666 23.3333 2.66666 16 2.66666C8.66666 2.66666 2.66666 8.66666 2.66666 16C2.66666 23.3333 8.66666 29.3333 16 29.3333C23.3333 29.3333 29.3333 23.3333 29.3333 16Z"
			:fill="backgroundColor" :stroke="strokeColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M12.2267 19.7734L19.7733 12.2267" :stroke="strokeColor" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round" />
		<path d="M19.7733 19.7734L12.2267 12.2267" :stroke="strokeColor" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round" />
	</svg>
</template>

<script>
export default {

	name: 'IconTrash',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '2rem', // px|em|rem|%
		},

		height_prop: {
			type: String,
			default: '2rem', // px|em|rem|%
		},

		backgroundColor: {
			type: String,
			default: 'white'
		},

		strokeColor: {
			type: String,
			default: '#007BFF'
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			// return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.width_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},

		height() {
			// return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.height_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}
}
</script>

<style lang="css" scoped></style>